import { AudioVersionResponseDTO } from '@core/api/dtos/response/audioVersion/audioVersion'
import { AudioVersion } from '@core/api/entities/audioVersion'

export class AudioVersionMapper {
	static toEntity = (dto: AudioVersionResponseDTO): AudioVersion => {
		return new AudioVersion({
			id: dto.id,
			name: dto.name,
		})
	}

	static toEntities = (dtos: AudioVersionResponseDTO[]): AudioVersion[] => {
		return dtos.map((dto) => AudioVersionMapper.toEntity(dto))
	}
}
